import React from 'react';
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { Lightbox } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { AccountAllowedStatusAction } from "../Action/AccountAllowedStatusAction";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { setActionMenuParams } from "../../../../../../../DLU/DLUHelper";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { SubaccountSideMenuMap } from "../../../../../CustomNavigation/Entities/SubaccountSideMenuMap";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../../react-core/Html/TextBoxEditor";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ValidatorContents } from "../../../../../../Common/ValidatorHelper";
import { AlphanumericWithSpace } from "../../../../../../../../react-core/Html/Validation/RegExPatterns";
import { accountStatusMap } from "../../../../ClientSearch/Resource/Content";
import { ProductOverviewProductInformationAction } from "../Action/ProductOverviewProductInformationAction";
import { Contents } from "../../Transactions/Resource/Contents";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { Table } from "../../../../../../../Shared/Table/Table";
import { ClientAccount } from '../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount';
import { SubAccount } from '../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount';

interface IProductOverviewProductInformationProps {
    data: any,
    name: string,
    subAccount: SubAccount,
    headAccount: ClientAccount,
    customerId: number,
    isValid: boolean,
    selectedStatus: any,
    setName: any,
    setIsValid: any,
    setSelectedStatus: any,
    setData: any
}

const ProductOverviewInformation = (props: IProductOverviewProductInformationProps) => {
    const [isShowEditLightbox, setIsShowEditLightbox] = React.useState(false);
    const [allowedStatus, setAllowedStatus] = React.useState(null);
 
    const { setSelectedStatus,selectedStatus, isValid, setData, data, name, setIsValid, setName, subAccount, customerId, headAccount } = props;
  
    return (
      <>

<div className="row wide-gutter">
                <div className="col-12 col-sm-fluid col-equalise">
                    <div className="d-flex f-direction-column">                 

                        <div className="row mb-10">
                            <div className="col-fluid col-middle">
                                <h2 className="h3 mb-0">Product information</h2>
                            </div>
                       
                            <div className="col-auto col-middle">
                                <Permission userClaim={UserClaim.AdviserPortalPortfolioViewRolesReadWrite}>
                                    <button
                                        type="button"
                                        className="edit-circle-icon-button label-sr-only"
                                        title="Edit"
                                        onClick={() => {
                                            AccountAllowedStatusAction.getAccountAllowedStatus(
                                                subAccount.HierarchyId,
                                                (result) => {
                                                    setAllowedStatus(result);
                                                    setIsShowEditLightbox(true);
                                                }
                                            );
                                        }}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text">Edit product name</span>
                                    </button>
                                </Permission>
                                {isShowEditLightbox && (
                                    <Lightbox
                                        cssWrapper="is-default-lightbox"
                                        show={isShowEditLightbox}
                                        onClose={() => setIsShowEditLightbox(false)}
                                        title="Edit product information"
                                    >
                                        {subAccount.SubAccountType == SubAccountType.InvestmentAccount && (
                                            <TextBoxEditor
                                                value={name}
                                                label={"Name"}
                                                onChange={(v) => setName(v)}
                                                required={"Please enter a name"}
                                                cssWrapper="control-size-430 mb-10"
                                                regex={{
                                                    errorMessage: ValidatorContents.AlphaNumericWithSpace,
                                                    value: AlphanumericWithSpace,
                                                }}
                                                onValidationResultChange={(isValid: boolean) => {
                                                    setIsValid(isValid);
                                                }}
                                                maxLength={80}
                                            />
                                        )}

                                        <SelectEditor
                                            id="customerStatus"
                                            label="Status"
                                            options={allowedStatus}
                                            getText={(v) => {
                                                return accountStatusMap[v];
                                            }}
                                            placeholder={"Please select status"}
                                            selected={selectedStatus}
                                            onChange={(v) => setSelectedStatus(v)}
                                        />
                                        <button
                                            className="btn secondary mr-10"
                                            onClick={() => {
                                                if (subAccount.SubAccountType == SubAccountType.InvestmentAccount) {
                                                    setName(
                                                        headAccount.SubAccounts.find(
                                                            (ele) => ele.HierarchyId == subAccount.HierarchyId
                                                        )?.ProductDisplayName
                                                    );
                                                }
                                                setSelectedStatus(null);
                                                setIsShowEditLightbox(false);
                                                setIsValid(true);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn primary"
                                            onClick={() => {
                                                if (isValid) {
                                                    if (subAccount.SubAccountType == SubAccountType.InvestmentAccount) {
                                                        headAccount.SubAccounts.find(
                                                            (ele) => ele.HierarchyId == subAccount.HierarchyId
                                                        ).ProductDisplayName = "PP - " + name;
                                                    }

                                                    setIsValid(true);
                                                    const hierarchyid = headAccount.SubAccounts.find(
                                                        (ele) => ele.HierarchyId == subAccount.HierarchyId
                                                    )?.HierarchyId;

                                                    ProductOverviewProductInformationAction.saveProductInformation(
                                                        hierarchyid,
                                                        name,
                                                        selectedStatus,
                                                        () => {
                                                            setIsShowEditLightbox(false);
                                                            setSelectedStatus(null);
                                                            ProductOverviewProductInformationAction.getProductInformation(
                                                                subAccount.HierarchyId,
                                                                (data) => {
                                                                    setData(data);
                                                                }
                                                            );
                                                        }
                                                    );
                                                }
                                            }}
                                        >
                                            Apply
                                        </button>
                                    </Lightbox>
                                )}
                            </div>
                         </div>
                        <div className="panel-subtle pt-10 pb-10">
                            {
                                <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted">
                                    <tbody>
                                        <tr>
                                            <th scope="row">Name</th>
                                            <td className="cell-right">{subAccount?.ProductDisplayName}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Status</th>
                                            <td className="cell-right">{data?.Status}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Date of closure</th>
                                            <td className="cell-right">
                                                {data?.ClosedDate && data?.ClosedDate + "" != Contents.InvalidateDate
                                                    ? JsonDateParser.getFormatDateString(
                                                          new Date(data?.ClosedDate),
                                                          "dd/MM/yyyy"
                                                      )
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        {(subAccount.SubAccountType == SubAccountType.OffshoreBond ||
                                            subAccount.SubAccountType == SubAccountType.OnshoreBond) && (
                                            <tr>
                                                <th scope="row">Policy number</th>
                                                <td className="cell-right">
                                                    {data?.PolicyNumber && data?.PolicyNumber.length > 0
                                                        ? data?.PolicyNumber
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                        )}
                                        <tr>
                                            <th scope="row">Inception date</th>
                                            <td className="cell-right">
                                                {data?.InceptionTime &&
                                                data?.InceptionTime + "" != Contents.InvalidateDate
                                                    ? JsonDateParser.getFormatDateString(
                                                          new Date(data?.InceptionTime),
                                                          "dd/MM/yyyy"
                                                      )
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Commission paying</th>
                                            <td className="cell-right">{data?.CommissionPaying ? "Yes" : "No"}</td>
                                        </tr>
                                        {data?.CommissionPaying == false && (
                                            <tr>
                                                <th scope="row">Date commission stopped being paid</th>
                                                <td className="cell-right">
                                                    {data?.DateStoppedCommissionPaying &&
                                                    data?.DateStoppedCommissionPaying + "" != Contents.InvalidateDate
                                                        ? JsonDateParser.getFormatDateString(
                                                              new Date(data?.DateStoppedCommissionPaying),
                                                              "dd/MM/yyyy"
                                                          )
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                        )}
                                        {subAccount.SubAccountType == SubAccountType.StocksIsa &&
                                            data?.FormerProductType !== "" && (
                                                <tr>
                                                    <th scope="row">Former product type</th>
                                                    <td className="cell-right">
                                                        {data?.FormerProductType && data?.FormerProductType.length > 0
                                                            ? data?.FormerProductType
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                            )}
                                        {subAccount.SubAccountType == SubAccountType.OffshoreBond && (
                                            <tr>
                                                <th scope="row">Number of segments</th>
                                                <td className="cell-right">
                                                    {data?.NumberOfSegments && data?.NumberOfSegments >= 0
                                                        ? data?.NumberOfSegments
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                     
                    </div>
                </div>
                <div className="col-12 col-sm-fluid col-equalise">
                    <div className="d-flex f-direction-column">
                        {(
                            <>
                                <h3>
                                 Manage investment income
                                    {/* <a type="button" className="edit-circle-icon-button ml-5" href={"/clients/cash/manageincome.aspx?claccountid=" + getQueryParameters()["claccountid"]} target="_blank">
                                                    <span className="icon"></span>
                                                    <span className="sr-only">Edit Ongoing Adviser Charge</span>
                                    </a> */}
                                </h3>
                                <div className="panel-subtle pt-10 pb-25">
                                    <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted mb-15">
                                        <tbody>
                                            <tr>
                                                <th scope="row">Instruction for income funds</th>
                                                <td className="cell-right">{data?.IncomeOption}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {checkPermission(UserClaim.AdviserPortalDluManageIncomeCanView) && (
                                        <div>
                                            <a
                                                href={
                                                    "/clients/cash/manageincome.aspx?claccountid=" +
                                                    headAccount?.HeadClAccountId
                                                }
                                                className="hyperlink"
                                                onClick={() => {
                                                    setActionMenuParams({
                                                        headaccounthierarchyId: headAccount?.HierarchyId,
                                                        subaccountHierarchyId: subAccount?.HierarchyId,
                                                        levelHierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                            HierarchyLevelName.Customer,
                                                            customerId
                                                        ),
                                                        SideMenu: SubaccountSideMenuMap.getSubMenuBySubAccountType(
                                                            subAccount?.SubAccountType
                                                        ),
                                                    });
                                                }}
                                            >
                                                View or edit income
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <hr />
            {(subAccount.SubAccountType == SubAccountType.OnshoreBond ||
                subAccount.SubAccountType == SubAccountType.OffshoreBond) && (
                <div className="row wide-gutter">
                    <div className="col-12 col-sm-fluid col-equalise">
                        <div className="d-flex f-direction-column">
                            <h2 className="mb-36">Lives Assured</h2> 
                            <div className="row mb-10" style={{ paddingLeft: "2px" }}>
                                <div className="panel-subtle pt-10 pb-10">
                                    <Table
                                        cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                        data={data?.LivesAssured}
                                        col={[
                                            {
                                                title: "Name",
                                                key: "Name",
                                            },
                                            {
                                                title: "Gender",
                                                key: "Gender",
                                            },
                                            {
                                                title: "Date Of Birth",
                                                key: "DateofBirth",
                                            },
                                            {
                                                title: "Address",
                                                key: "Address",
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
      </>
    )
};
  
export default ProductOverviewInformation;